import { initializeApp } from "firebase/app";
import {
  getAuth,
  connectAuthEmulator,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";
import { getAnalytics, logEvent, setUserId } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBoVm2gpor_2hjjaSHJDTBHD5pz34MT53Y",
  authDomain: "sodtf-fb.firebaseapp.com",
  projectId: "sodtf-fb",
  storageBucket: "gs://sodtf-fb.firebasestorage.app",
  messagingSenderId: "945104356035",
  appId: "1:945104356035:web:0197158000e96c8378d876",
  measurementId: "G-FFB4K0FYN0"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");
export const rtdb = getDatabase(app);
export { analytics, logEvent, setUserId };

const flag = (value) => {
  const normalized = String(value || '').toLowerCase();
  if (["true", "1", "yes", "on"].includes(normalized)) return true;
  if (["false", "0", "no", "off"].includes(normalized)) return false;
  return false;
};

// Optional: connect to Firebase emulators for local testing
if (flag(process.env.REACT_APP_USE_EMULATORS)) {
  const useAuthEmulator = flag(process.env.REACT_APP_USE_AUTH_EMULATOR);
  const useFirestoreEmulator = flag(process.env.REACT_APP_USE_FIRESTORE_EMULATOR ?? 'true');
  const useFunctionsEmulator = flag(process.env.REACT_APP_USE_FUNCTIONS_EMULATOR ?? 'true');
  const useStorageEmulator = flag(process.env.REACT_APP_USE_STORAGE_EMULATOR ?? 'true');
  const useDbEmulator = flag(process.env.REACT_APP_USE_DB_EMULATOR);
  try {
    if (useAuthEmulator) {
      connectAuthEmulator(auth, 'http://localhost:9099', {
        disableWarnings: true,
      });
      setPersistence(auth, browserLocalPersistence).catch((err) => {
        console.warn('⚠️ Failed to set auth persistence for emulator:', err);
      });
    }
  } catch (_) { }
  try {
    if (useFirestoreEmulator) {
      connectFirestoreEmulator(db, '127.0.0.1', 8080);
    }
  } catch (_) { }
  try {
    if (useStorageEmulator) {
      connectStorageEmulator(storage, '127.0.0.1', 9199);
    }
  } catch (_) { }
  try {
    if (useFunctionsEmulator) {
      connectFunctionsEmulator(functions, '127.0.0.1', 5001);
    }
  } catch (_) { }
  try {
    if (useDbEmulator) {
      connectDatabaseEmulator(rtdb, '127.0.0.1', 9000);
    }
  } catch (_) { }
}
